// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
html {
  scroll-behavior: smooth;
}
body {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
/* Panel */
.panel {
  position: relative;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* Navbar */
/* Sidebar */
.sidebar:hover .nav-item > a {
  width: auto;
}
.sidebar .nav-item > button,
  .sidebar .nav-item > a {
  margin-bottom: 0.25rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 0.375rem;
  padding: 0.625rem;
  --tw-text-opacity: 1;
  color: rgb(80 102 144 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button:hover,
  .sidebar .nav-item > a:hover {
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button.active,
  .sidebar .nav-item > a.active {
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.sidebar ul.sub-menu li button.active,
  .sidebar ul.sub-menu li a.active {
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.sidebar ul.sub-menu li button.active::before,
  .sidebar ul.sub-menu li a.active::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}
.sidebar .nav-item a div:first-child svg,
  .sidebar .nav-item button div:first-child svg {
  height: 1.25rem;
  width: 1.25rem;
  color: rgb(14 23 38 / 0.5);
}
/* Horizontal layouts */
.horizontal .nav-item a div:first-child svg {
  height: 1.25rem;
  width: 1.25rem;
  color: rgb(14 23 38 / 0.5);
}
.horizontal .dark .nav-item a div:first-child svg,
  .dark.horizontal .nav-item a div:first-child svg {
  color: rgb(255 255 255 / 0.5);
}
.horizontal-menu .nav-link {
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.horizontal-menu .nav-link:hover {
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
@media (min-width: 1280px) {

  .horizontal-menu .nav-link {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.horizontal-menu .nav-link.active {
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.horizontal-menu ul.sub-menu a.active {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.horizontal-menu > li.nav-item:hover > ul.sub-menu,
  .horizontal-menu > li.nav-item > ul.sub-menu > li:hover > ul {
  display: block;
}
/* Vertical layouts */
/* Collapsible vertical layouts */
.collapsible-vertical.toggle-sidebar .sidebar .nav-item > a {
  width: auto;
}
/* boxed-layout */
/* Buttons */
.btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-shadow: 0 10px 20px -10px;
  --tw-shadow-colored: 0 10px 20px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.btn:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-lg {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
.btn-sm {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
.btn[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}
.btn-primary {
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(67 97 238 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(128 93 202 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-success {
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(0 171 85 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-danger {
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(231 81 90 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-dlight {
  --tw-border-opacity: 1;
  border-color: rgb(255 70 19 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 70 19 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(255 70 19 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-outline-dlight {
  --tw-border-opacity: 1;
  border-color: rgb(255 70 19 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 70 19 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-outline-dlight:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 70 19 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.btn-info {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(33 150 243 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-outline-info {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-outline-info:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
/* Badge */
.badge {
  position: relative;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: transparent;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
/* Form */
.form-input,
  .form-textarea,
  .form-select,
  .form-multiselect {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.form-input:focus,
  .form-textarea:focus,
  .form-select:focus,
  .form-multiselect:focus {
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-ring-color: transparent;
}
label {
  margin-bottom: 0.375rem;
  display: block;
  font-weight: 600;
}
[dir='rtl'] select {
    background-position: left 0.5rem center;
  }
.has-error .form-input,
  .has-error .form-textarea,
  .has-error .form-select,
  .has-error .form-multiselect,
  .has-error .multiselect__tags {
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  background-color: rgb(231 81 90 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}
.has-error .form-input::placeholder,
  .has-error .form-textarea::placeholder,
  .has-error .form-select::placeholder,
  .has-error .form-multiselect::placeholder,
  .has-error .multiselect__tags::placeholder {
  color: rgb(231 81 90 / 0.7);
}
.has-error .form-input:focus,
  .has-error .form-textarea:focus,
  .has-error .form-select:focus,
  .has-error .form-multiselect:focus,
  .has-error .multiselect__tags:focus {
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
}
.has-error .multiselect__tags:hover,
  .has-error .form-checkbox {
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
}
.has-success .form-input,
  .has-success .form-textarea,
  .has-success .form-select,
  .has-success .form-multiselect,
  .has-success .multiselect__tags {
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  background-color: rgb(0 171 85 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(0 171 85 / var(--tw-text-opacity, 1));
}
.has-success .form-input::placeholder,
  .has-success .form-textarea::placeholder,
  .has-success .form-select::placeholder,
  .has-success .form-multiselect::placeholder,
  .has-success .multiselect__tags::placeholder {
  color: rgb(0 171 85 / 0.7);
}
.has-success .form-input:focus,
  .has-success .form-textarea:focus,
  .has-success .form-select:focus,
  .has-success .form-multiselect:focus,
  .has-success .multiselect__tags:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
}
/* checkbox & radio */
.form-radio,
  .form-checkbox {
  height: 1.25rem;
  width: 1.25rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
  --tw-ring-offset-width: 0px !important;
}
.form-radio:checked,
  .form-checkbox:checked {
  background-size: 90% 90%;
}
.form-radio:disabled,
  .form-checkbox:disabled {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity, 1));
}
.form-radio:where([dir="ltr"], [dir="ltr"] *),
  .form-checkbox:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.375rem;
}
.form-radio:where([dir="rtl"], [dir="rtl"] *),
  .form-checkbox:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.375rem;
}
.form-checkbox.outline-primary:checked {
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%234361ee' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-secondary:checked {
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23805dca' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-success:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%2300ab55' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-danger:checked {
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e7515a' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-warning:checked {
  --tw-border-opacity: 1;
  border-color: rgb(226 160 63 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e2a03f' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-info:checked {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%232196f3' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
.form-checkbox.outline-dark:checked {
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  background-color: transparent;
    background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%233b3f5c' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>");
}
/* dropdown */
.dropdown {
  position: relative;
}
.dropdown > button {
  display: flex;
}
.dropdown ul {
  position: absolute;
  z-index: 10;
  margin-top: 0.25rem;
  min-width: 120px;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    /* @apply my-1 min-w-[120px] rounded bg-white p-0 py-2 shadow dark:bg-[#1b2e4b]  text-black dark:text-white-dark; */
}
.dropdown ul li > a,
  .dropdown ul li > button {
  display: flex;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.dropdown ul li > a:hover,
  .dropdown ul li > button:hover {
  background-color: rgb(255 70 19 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(255 70 19 / var(--tw-text-opacity, 1));
}
.dropdown ul li > button {
  width: 100%;
}
/* tables */
table {
  width: 100%;
  border-collapse: collapse !important;
}
table thead tr,
  table tfoot tr {
  border-bottom-width: 0px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 248 250 / var(--tw-bg-opacity, 1)) !important;
}
table thead tr th,
  table tfoot tr th,
  table tbody tr td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
table thead tr th:where([dir="ltr"], [dir="ltr"] *),
  table tfoot tr th:where([dir="ltr"], [dir="ltr"] *),
  table tbody tr td:where([dir="ltr"], [dir="ltr"] *) {
  text-align: left;
}
table thead tr th:where([dir="rtl"], [dir="rtl"] *),
  table tfoot tr th:where([dir="rtl"], [dir="rtl"] *),
  table tbody tr td:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
table thead tr th,
  table tfoot tr th {
  font-weight: 600;
}
table tbody tr {
  border-bottom-width: 1px;
  border-color: rgb(224 230 237 / 0.4) !important;
}
/* code hightlight */
pre {
    direction: ltr;
  }
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.relative {
  position: relative;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.m-auto {
  margin: auto;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-28 {
  margin-left: 7rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-14 {
  height: 3.5rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-14 {
  width: 3.5rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-none {
  flex: none;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow-0 {
  flex-grow: 0;
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-move {
  cursor: move;
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.overflow-x-auto {
  overflow-x: auto;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-4 {
  border-width: 4px;
}
.border-8 {
  border-width: 8px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-\\[\\#f1f2f3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(241 242 243 / var(--tw-border-opacity, 1));
}
.border-dlight {
  --tw-border-opacity: 1;
  border-color: rgb(255 70 19 / var(--tw-border-opacity, 1));
}
.border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-l-dlight {
  --tw-border-opacity: 1;
  border-left-color: rgb(255 70 19 / var(--tw-border-opacity, 1));
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
}
.bg-danger\\/20 {
  background-color: rgb(231 81 90 / 0.2);
}
.bg-dlight {
  --tw-bg-opacity: 1;
  background-color: rgb(255 70 19 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-info\\/20 {
  background-color: rgb(33 150 243 / 0.2);
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
}
.bg-success\\/20 {
  background-color: rgb(0 171 85 / 0.2);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
}
.bg-warning\\/20 {
  background-color: rgb(226 160 63 / 0.2);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-red-500 {
  --tw-gradient-to: rgb(239 68 68 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ef4444 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-center {
  text-align: center;
}
.align-middle {
  vertical-align: middle;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.text-black-dark-light {
  color: rgba(14,23,38,.15);
}
.text-danger {
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}
.text-dlight {
  --tw-text-opacity: 1;
  color: rgb(255 70 19 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-info {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-success {
  --tw-text-opacity: 1;
  color: rgb(0 171 85 / var(--tw-text-opacity, 1));
}
.text-warning {
  --tw-text-opacity: 1;
  color: rgb(226 160 63 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white-dark {
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* perfect scrollbar */
.ng-scrollbar {
  --scrollbar-size: 6px !important;
  --scrollbar-thumb-color: #dddddd !important;
  --scrollbar-padding: 0px !important;
}

.collapsible-vertical .sidebar .ng-scroll-content {
  display: block !important;
}

.sidebar .ng-scrollbar {
  --scrollbar-padding: 2px !important;
}

.dark .ng-scrollbar {
  --scrollbar-thumb-color: #2d334c !important;
}

/* swal2 */
.swal2-container .swal2-close {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-close:hover {
  --tw-text-opacity: 1;
  color: rgb(234 234 236 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-close:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.swal2-container .swal2-popup.swal2-toast {
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.swal2-popup.swal2-toast .swal2-title,
.swal2-container .swal2-popup.swal2-toast .swal2-html-container {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}

.swal2-container .swal2-popup.swal2-toast.color-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
}

.swal2-container .swal2-popup.swal2-toast.color-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-info {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-success {
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
}

/* apex chart */
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light,
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light {
  box-shadow: none;
  border-color: #050717cc;
  background-color: #050717cc;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.apexcharts-canvas .apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas .apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #050717cc;
}

.apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(6 8 24 / var(--tw-bg-opacity, 1));
}

.apexcharts-legend-series:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.5rem !important;
}

.apexcharts-legend-series:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.5rem !important;
}

.dark .apexcharts-title-text {
  fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-text.apexcharts-xaxis-label,
.dark .apexcharts-canvas .apexcharts-text.apexcharts-yaxis-label {
  fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-text,
.dark .apexcharts-canvas .apexcharts-text {
  fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-legend-text {
  color: #e0e6ed !important;
}

.dark .apexcharts-canvas .apexcharts-radialbar-track.apexcharts-track .apexcharts-radialbar-area {
  stroke: #191e3a;
}
.dark .apexcharts-canvas .apexcharts-series-markers.apexcharts-series-bubble .apexcharts-marker {
  stroke: #191e3a;
}

.dark .apexcharts-canvas .apexcharts-pie-label,
.dark .apexcharts-canvas .apexcharts-datalabel,
.dark .apexcharts-canvas .apexcharts-datalabel-label,
.dark .apexcharts-canvas .apexcharts-datalabel-value {
  fill: #bfc9d4;
}

.dark .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {
  box-shadow: none;
}

.apexcharts-canvas .apexcharts-legend-marker:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.375rem !important;
}

.apexcharts-canvas .apexcharts-legend-marker:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0px !important;
  margin-left: 0.375rem;
}

[dir='rtl'] .apexcharts-tooltip-marker {
  margin-left: 0.625rem;
  margin-right: 0px;
}

/* Animations */
.slide-down-enter-active {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.slide-down-leave-active {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.slide-down-enter-from,
.slide-down-leave-to {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 1;
}

.modal-fade-enter-active {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.modal-fade-leave-active {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 0;
}
.modal-fade-enter-to,
.modal-fade-leave-from {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 1;
}

/* highlightjs */
pre code.hljs {
  overflow-x: auto;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(25 30 58 / var(--tw-bg-opacity, 1)) !important;
  padding: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* ngx-scrollbar */
.ng-scroll-viewport {
  width: 100%;
}


.small-box-shadow {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

body.swal2-toast-shown .swal2-container.toast {
  width: 400px;
}

.swal2-popup {
  flex-direction: column;
  justify-content: center;
  padding: 20px !important;
  box-sizing: border-box;
}

.dark .swal2-popup {
  background: #0e1726;
}

.dark .swal2-popup .swal2-title {
  color: #888ea8;
}

.swal2-popup .swal2-title {
  display: block;
  margin: 0px !important;
  width: 100%;
  color: #3b3f5c;
  font-size: 24px;
}

.swal2-popup .swal2-title:where([dir="ltr"], [dir="ltr"] *) {
  padding-right: 2.5rem !important;
}

.swal2-popup .swal2-title:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 2.5rem !important;
}

.swal2-popup .swal2-styled {
  box-shadow: 0px 5px 20px 0 rgba(0, 0, 0, 0.1) !important;
  letter-spacing: 1px;
  font-size: 14px !important;
  line-height: 20px !important;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  margin: 0 5px;
  padding: 8px 20px;
  border-radius: 6px;
}

.swal2-popup .swal2-styled.swal2-cancel {
  background-color: #fff !important;
  color: #4361ee;
  border: 1px solid #e8e8e8;
  box-shadow: none;
  padding: 7px 20px;
}

.dark .swal2-popup .swal2-styled.swal2-cancel {
  background-color: #3b3f5c !important;
  color: #e0e6ed;
  border-color: #3b3f5c;
}

.swal2-popup .swal2-styled.swal2-confirm {
  background-color: #4361ee;
}

.swal2-popup .swal2-styled.swal2-confirm:focus {
  box-shadow: none !important;
}

.swal2-popup .swal2-html-container {
  margin: 0 !important;
  color: #e95f2b;
  font-weight: 300;
}

.swal2-popup .swal2-html-container:where([dir="ltr"], [dir="ltr"] *) {
  padding-right: 2.5rem !important;
}

.swal2-popup .swal2-html-container:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 2.5rem !important;
}

.swal2-popup .swal2-close {
  position: absolute;
  top: 16px;
  transition: color 0.1s ease-out;
  font-family: serif;
}

.swal2-popup .swal2-close:where([dir="ltr"], [dir="ltr"] *) {
  right: 1rem;
}

.swal2-popup .swal2-close:where([dir="rtl"], [dir="rtl"] *) {
  left: 1rem;
}

.dark .swal2-popup .swal2-close {
  color: #888ea8;
}

.swal2-popup.swal2-toast {
  flex-direction: row;
  align-items: center;
  width: auto !important;
  box-shadow: 0 0 0.625em #d9d9d9;
  padding: 2em;
  overflow-y: hidden;
  display: flex !important;
}

.swal2-popup.swal2-toast.swal2-show {
  animation: showSweetToast 0.5s;
}

.swal2-popup pre {
  color: #009688;
}

.swal2-icon {
  position: relative;
  box-sizing: content-box;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  border: 0.25em solid transparent;
  border-radius: 50%;
  border-color: #000;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}

.sweet-alerts .swal2-icon:not(.swal2-error):not(.swal2-success) {
  width: 2em !important;
  line-height: 119px !important;
  height: 2em !important;
  margin: 0.25em auto 0.875em !important;
}

.swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
  height: 3px !important;
}

.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
  width: 16px !important;
  top: 11px !important;
}

.swal2-icon.swal2-error {
  border-color: #e7515a !important;
  border: 4px solid #f1f2f3 !important;
  box-shadow: 0px 3px 25px 0px rgb(113 106 202 / 20%);
}

.swal2-icon.swal2-warning {
  color: #fb4 !important;
  border: 4px solid #f1f2f3 !important;
  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);
  text-align: center;
}

.sweet-alerts .swal2-icon.swal2-warning,
.sweet-alerts .swal2-icon.swal2-question,
.sweet-alerts .swal2-icon.swal2-info {
  font-size: 60px;
  line-height: 80px;
}

.swal2-popup.swal2-toast .swal2-icon {
  height: 26px !important;
  width: 26px !important;
  min-width: 26px !important;
  border-width: 2px !important;
}

.swal2-icon.swal2-info {
  color: #4361ee !important;
  border: 4px solid #f1f2f3 !important;
  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);
  text-align: center;
}

.swal2-icon.swal2-question {
  color: #805dca !important;
  border: solid 4px #ebedf2 !important;
  border-color: none !important;
  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);
  text-align: center;
}

.dark .swal2-icon.swal2-question,
.dark .swal2-icon.swal2-info,
.dark .swal2-icon.swal2-warning,
.dark .swal2-icon.swal2-error {
  border-color: #888ea8 !important;
  box-shadow: none !important;
}

.swal2-iconswal2-success [class^='swal2-success-line'][class\$='tip'] {
  top: 2.875em;
  left: 0.875em;
  width: 1.5625em;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success swal2-success [class^='swal2-success-line'][class\$='long'] {
  top: 2.375em;
  right: 0.5em;
  width: 2.9375em;
  transform: rotate(-45deg);
}

.swal2-icon.swal2-success .swal2-success-fix {
  position: absolute;
  top: 0.5em;
  left: 1.625em;
  width: 0.4375em;
  height: 5.625em;
  transform: rotate(-45deg);
  z-index: 1;
}

.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  top: -0.25em;
  left: -0.25em;
  width: 100%;
  height: 100%;
  border: 0.25em solid rgba(165, 220, 134, 0.3);
  border-radius: 50%;
  z-index: 2;
  box-sizing: content-box;
}

.swal2-icon.swal2-success [class^='swal2-success-circular-line'][class\$='right'] {
  top: -0.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #25d5e4 !important;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
  background: #ebedf2 !important;
}

.dark .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
  background: #3b3f5c !important;
  color: #888ea8 !important;
}

.dark .swal2-progress-steps .swal2-progress-step {
  color: #e0e6ed;
}

.sweet-alerts .swal2-icon-content {
  font-size: 5.75rem !important;
}
.swal2-icon-content {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}

.swal2-show {
  animation: swal2-show 0.3s;
}

.swal2-modal.background-modal .swal2-title {
  color: #fff !important;
}

.dark .swal2-input {
  background-color: #1b2e4b;
  border-color: #253b5c;
  color: #888ea8;
}

.dark .swal2-footer {
  border-color: #888ea8;
}

.swal2-image {
  margin-bottom: 32px !important;
}

.sweet-alerts.swal2-popup .swal2-html-container {
  margin-top: 1rem !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.sweet-alerts.swal2-popup .swal2-title:where([dir="ltr"], [dir="ltr"] *) {
  padding-right: 1.5rem !important;
}

.sweet-alerts.swal2-popup .swal2-title:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 1.5rem !important;
}

.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {
  width: 24px !important;
  height: 26px !important;
}

.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class\$='left'] {
  top: -0.8em;
  left: -0.5em;
  transform: rotate(-45deg);
  transform-origin: 2em 2em;
  border-radius: 4em 0 0 4em;
}

.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='tip'] {
  top: 15px !important;
  left: 3px !important;
  width: 9px !important;
}

.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='long'] {
  top: 14px !important;
  right: 2px !important;
  width: 16px !important;
}

.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
  width: 26px !important;
  height: 26px !important;
}

.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  z-index: 2 !important;
  top: -2px !important;
  left: -2px !important;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  border: 2px solid rgba(165, 220, 134, 0.3);
  border-radius: 50%;
}

.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class\$='left'] {
  transform-origin: 26px 26px !important;
  border-radius: 2em 0 0 2em !important;
}
.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {
  width: 20px !important;
  height: 43px !important;
}
.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='tip'] {
  top: 15px !important;
  left: 4px !important;
  width: 8px !important;
}
.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'] {
  height: 3px !important;
}
.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='long'] {
  top: 12px !important;
  right: 3px !important;
  width: 16px !important;
}
.swal2-icon.swal2-success .swal2-success-ring {
  top: -2px !important;
  left: -2px !important;
  border: 3px solid rgba(165, 220, 134, 0.3) !important;
}
.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class\$='right'] {
  border-radius: 0 2em 2em 0 !important;
}



.swal2-popup {
  flex-direction: column;
  justify-content: center;
  padding: 20px!important;
  box-sizing: border-box
}

.dark .swal2-popup {
  background: #0e1726
}

.dark .swal2-popup .swal2-title {
  color: #888ea8
}

.swal2-popup .swal2-title {
  display: block;
  margin: 0!important;
  width: 100%;
  color: #3b3f5c;
  font-size: 24px
}

.swal2-popup .swal2-title:where([dir=ltr],[dir=ltr] *) {
  padding-right: 2.5rem!important
}

.swal2-popup .swal2-title:where([dir=rtl],[dir=rtl] *) {
  padding-left: 2.5rem!important
}

.swal2-popup .swal2-styled {
  box-shadow: 0 5px 20px 0 #0000001a!important;
  letter-spacing: 1px;
  font-size: 14px!important;
  line-height: 20px!important;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  margin: 0 5px;
  padding: 8px 20px;
  border-radius: 6px
}

.swal2-popup .swal2-styled.swal2-cancel {
  background-color: #fff!important;
  color: #4361ee;
  border: 1px solid #e8e8e8;
  box-shadow: none;
  padding: 7px 20px
}

.dark .swal2-popup .swal2-styled.swal2-cancel {
  background-color: #3b3f5c!important;
  color: #e0e6ed;
  border-color: #3b3f5c
}

.swal2-popup .swal2-styled.swal2-confirm {
  background-color: #4361ee
}

.swal2-popup .swal2-styled.swal2-confirm:focus {
  box-shadow: none!important
}

.swal2-popup .swal2-html-container {
  margin: 0!important;
  color: #e95f2b;
  font-weight: 300
}

.swal2-popup .swal2-html-container:where([dir=ltr],[dir=ltr] *) {
  padding-right: 2.5rem!important
}

.swal2-popup .swal2-html-container:where([dir=rtl],[dir=rtl] *) {
  padding-left: 2.5rem!important
}

.swal2-popup .swal2-close {
  position: absolute;
  top: 16px;
  transition: color .1s ease-out;
  font-family: serif
}

.swal2-popup .swal2-close:where([dir=ltr],[dir=ltr] *) {
  right: 1rem
}

.swal2-popup .swal2-close:where([dir=rtl],[dir=rtl] *) {
  left: 1rem
}

.dark .swal2-popup .swal2-close {
  color: #888ea8
}

.swal2-popup.swal2-toast {
  flex-direction: row;
  align-items: center;
  width: auto!important;
  box-shadow: 0 0 .625em #d9d9d9;
  padding: 2em;
  overflow-y: hidden;
  display: flex!important
}

.swal2-popup.swal2-toast.swal2-show {
  animation: showSweetToast .5s
}

.swal2-popup pre {
  color: #009688
}

.swal2-icon {
  position: relative;
  box-sizing: initial;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  border-radius: 50%;
  border: .25em solid #000;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
  user-select: none
}

.swal2-icon:not(.swal2-error):not(.swal2-success) {
  width: 2em!important;
  line-height: 119px!important;
  height: 2em!important;
  margin: .25em auto .875em!important
}

.swal2-icon.swal2-error {
  border: 5px solid #f1f2f3!important;
  box-shadow: 0 3px 25px 0 #716aca33
}

.swal2-icon.swal2-warning {
  color: #fb4!important
}

.swal2-icon.swal2-info,.swal2-icon.swal2-warning {
  border: 5px solid #f1f2f3!important;
  box-shadow: 0 3px 25px 0 #716aca33;
  font-size: 60px;
  line-height: 80px;
  text-align: center
}

.swal2-icon.swal2-info {
  color: #4361ee!important
}

.swal2-icon.swal2-question {
  color: #805dca!important;
  border-style: solid;
  border-width: 4px!important;
  border-color: #0000!important;
  box-shadow: 0 3px 25px 0 #716aca33;
  font-size: 60px;
  line-height: 80px;
  text-align: center
}

.dark .swal2-icon.swal2-error,.dark .swal2-icon.swal2-info,.dark .swal2-icon.swal2-question,.dark .swal2-icon.swal2-warning {
  border-color: #888ea8!important;
  box-shadow: none!important
}

.swal2-iconswal2-success [class^=swal2-success-line][class\$=tip] {
  top: 2.875em;
  left: .875em;
  width: 1.5625em;
  transform: rotate(45deg)
}

.swal2-icon.swal2-success swal2-success [class^=swal2-success-line][class\$=long] {
  top: 2.375em;
  right: .5em;
  width: 2.9375em;
  transform: rotate(-45deg)
}

.swal2-icon.swal2-success .swal2-success-fix {
  position: absolute;
  top: .5em;
  left: 1.625em;
  width: .4375em;
  height: 5.625em;
  transform: rotate(-45deg);
  z-index: 1
}

.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  top: -.25em;
  left: -.25em;
  width: 100%;
  height: 100%;
  border: .25em solid #a5dc864d;
  border-radius: 50%;
  z-index: 2;
  box-sizing: initial
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #25d5e4!important
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step {
  background: #ebedf2!important
}

.dark .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step {
  background: #3b3f5c!important;
  color: #888ea8!important
}

.dark .swal2-progress-steps .swal2-progress-step {
  color: #e0e6ed
}

.swal2-icon-content {
  font-size: 5.75rem!important
}

.swal2-show {
  animation: swal2-show .3s
}

.swal2-modal.background-modal .swal2-title {
  color: #fff!important
}

.dark .swal2-input {
  background-color: #1b2e4b;
  border-color: #253b5c;
  color: #888ea8
}

.dark .swal2-footer {
  border-color: #888ea8
}

.swal2-image {
  margin-bottom: 32px!important
}

.sweet-alerts.swal2-popup .swal2-html-container {
  margin-top: 1rem!important;
  padding-left: 0!important;
  padding-right: 0!important
}

.sweet-alerts.swal2-popup .swal2-title:where([dir=ltr],[dir=ltr] *) {
  padding-right: 1.5rem!important
}

.sweet-alerts.swal2-popup .swal2-title:where([dir=rtl],[dir=rtl] *) {
  padding-left: 1.5rem!important
}
.swal2-popup .swal2-styled.swal2-confirm {
  background-color: #4361ee!important;
}

.box-shadow-pop {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px!important;
  transition: all 0.2s ease-in-out!important;
}

.box-shadow-pop:hover {
 box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 10px 5px!important
}

.form-input-focus {
  transition: 0.4s ease-in-out;
}

.form-input-focus:focus {
  box-shadow: 1px 0 10px 1px rgba(255,70,30, 0.1)!important;
  border:1px solid rgba(255,70,30, 1)!important
}


.stacked{
  top:0;
  transition: top ease 0.3s;
  position:relative;
  right:2px;
}
.stacked:hover {
  top: -10px;
}
.avatar-box{
  display:table-cell;
  vertical-align:middle;

}
.avatar {
  display: table-cell;
  vertical-align:middle;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
}


.avatar-sm{
  width:2vw;
  height:2vw;
  font-size:1vw;
}



.color-picker {
  -webkit-appearance: none;
  padding: 0;
  border: none;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  cursor:pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px!important
}
.color-picker::-webkit-color-swatch {
  border: none;
  border-radius: 10px;
  padding: 0;
}
.color-picker::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: 10px;
  padding: 0;
}
.color-picker:hover {
  transform: scaleX(1.3) scaleY(1.3);
  box-shadow: rgba(0, 0, 0, 0.6) 0px 2px 5px 0px!important
}

.color-picker:focus {
  transform: scaleX(1.3) scaleY(1.3);
  box-shadow: rgba(0, 0, 0, 0.6) 0px 2px 5px 0px!important
}


.assignee-box {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.small-dlight-box-shadow{
  box-shadow: 0 3px 10px 1px rgba(255, 70, 19, 0.5)
}


.noclip {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.hover\\:top-0:hover {
  top: 0px;
}


.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}


.hover\\:text-danger:hover {
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}


.hover\\:text-dlight:hover {
  --tw-text-opacity: 1;
  color: rgb(255 70 19 / var(--tw-text-opacity, 1));
}


.hover\\:text-info:hover {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}


.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}


.hover\\:opacity-100:hover {
  opacity: 1;
}


.ltr\\:right-0:where([dir="ltr"], [dir="ltr"] *) {
  right: 0px;
}


.ltr\\:ml-2:where([dir="ltr"], [dir="ltr"] *) {
  margin-left: 0.5rem;
}


.ltr\\:mr-1\\.5:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.375rem;
}


.ltr\\:mr-2:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.5rem;
}


.ltr\\:mr-3:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.75rem;
}


.rtl\\:left-0:where([dir="rtl"], [dir="rtl"] *) {
  left: 0px;
}


.rtl\\:ml-1\\.5:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.375rem;
}


.rtl\\:ml-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.5rem;
}


.rtl\\:ml-3:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.75rem;
}


.rtl\\:mr-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0.5rem;
}


.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/tailwind.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAMV;EAAA,uBAAA;AAAoB;AAIpB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAOrB,UAAU;AAER;EAAA,kBAA+C;EAA/C,uBAA+C;EAA/C,kBAA+C;EAA/C,4DAA+C;EAA/C,gBAA+C;EAA/C,0EAA+C;EAA/C,8FAA+C;EAA/C,uGAAA;AAA+C;AAGjD,WAAW;AAkBX,YAAY;AAEV;EAAA,WAAA;AAAa;AAKb;;EAAA,sBAA+J;EAA/J,aAA+J;EAA/J,WAA+J;EAA/J,mBAA+J;EAA/J,8BAA+J;EAA/J,gBAA+J;EAA/J,mBAA+J;EAA/J,uBAA+J;EAA/J,iBAA+J;EAA/J,oBAA+J;EAA/J,kDAAA;AAA+J;AAA/J;;EAAA,mCAA+J;EAA/J,oBAA+J;EAA/J,gDAAA;AAA+J;AAI/J;;EAAA,mCAAmC;EAAnC,oBAAmC;EAAnC,gDAAA;AAAmC;AAYnC;;EAAA,oBAAqC;EAArC,iDAAA;AAAqC;AAArC;;EAAA,0BAAqC;EAArC,kBAAqC;EAArC,0DAAA;AAAqC;AAKrC;;EAAA,eAA6B;EAA7B,cAA6B;EAA7B,0BAAA;AAA6B;AAO/B,uBAAuB;AAkBrB;EAAA,eAA6B;EAA7B,cAA6B;EAA7B,0BAAA;AAA6B;AAK7B;;EAAA,6BAAA;AAAoB;AAIpB;EAAA,aAAgG;EAAhG,mBAAgG;EAAhG,qBAAgG;EAAhG,oBAAgG;EAAhG,qBAAgG;EAAhG,qBAAgG;EAAhG,wBAAA;AAAgG;AAAhG;EAAA,mCAAgG;EAAhG,oBAAgG;EAAhG,gDAAA;AAAgG;AAAhG;;EAAA;IAAA,kBAAgG;IAAhG,mBAAA;EAAgG;AAAA;AAIhG;EAAA,mCAAmC;EAAnC,oBAAmC;EAAnC,gDAAA;AAAmC;AAYnC;EAAA,kBAAgC;EAAhC,4DAAgC;EAAhC,oBAAgC;EAAhC,iDAAA;AAAgC;AAKhC;;EAAA,cAAA;AAAY;AAGd,qBAAqB;AAerB,iCAAiC;AAW/B;EAAA,WAAA;AAAa;AAgDf,iBAAiB;AAcjB,YAAY;AAEV;EAAA,kBAAoL;EAApL,aAAoL;EAApL,mBAAoL;EAApL,uBAAoL;EAApL,uBAAoL;EAApL,iBAAoL;EAApL,qBAAoL;EAApL,sBAAoL;EAApL,mBAAoL;EAApL,sBAAoL;EAApL,mBAAoL;EAApL,oBAAoL;EAApL,gBAAoL;EAApL,8BAAoL;EAApL,6DAAoL;EAApL,uGAAoL;EAApL,8BAAoL;EAApL,mBAAoL;EAApL,gKAAoL;EAApL,wJAAoL;EAApL,iLAAoL;EAApL,wDAAoL;EAApL,0BAAA;AAAoL;AAApL;EAAA,sBAAoL;EAApL,8BAAoL;EAApL,uGAAA;AAAoL;AAGpL;EAAA,qBAA4B;EAA5B,sBAA4B;EAA5B,qBAA4B;EAA5B,wBAA4B;EAA5B,eAA4B;EAA5B,mBAAA;AAA4B;AAG5B;EAAA,sBAA4B;EAA5B,uBAA4B;EAA5B,qBAA4B;EAA5B,wBAA4B;EAA5B,kBAA4B;EAA5B,iBAAA;AAA4B;AAG5B;EAAA,mBAAoC;EAApC,YAAA;AAAoC;AAIpC;EAAA,sBAA6D;EAA7D,0DAA6D;EAA7D,kBAA6D;EAA7D,0DAA6D;EAA7D,oBAA6D;EAA7D,mDAA6D;EAA7D,uCAA6D;EAA7D,qCAAA;AAA6D;AAO7D;EAAA,sBAAmE;EAAnE,2DAAmE;EAAnE,kBAAmE;EAAnE,2DAAmE;EAAnE,oBAAmE;EAAnE,mDAAmE;EAAnE,wCAAmE;EAAnE,qCAAA;AAAmE;AAOnE;EAAA,sBAA6D;EAA7D,yDAA6D;EAA7D,kBAA6D;EAA7D,yDAA6D;EAA7D,oBAA6D;EAA7D,mDAA6D;EAA7D,sCAA6D;EAA7D,qCAAA;AAA6D;AAO7D;EAAA,sBAA0D;EAA1D,0DAA0D;EAA1D,kBAA0D;EAA1D,0DAA0D;EAA1D,oBAA0D;EAA1D,mDAA0D;EAA1D,uCAA0D;EAA1D,qCAAA;AAA0D;AAO1D;EAAA,sBAA0D;EAA1D,0DAA0D;EAA1D,kBAA0D;EAA1D,0DAA0D;EAA1D,oBAA0D;EAA1D,mDAA0D;EAA1D,uCAA0D;EAA1D,qCAAA;AAA0D;AAQ1D;EAAA,sBAA6E;EAA7E,0DAA6E;EAA7E,oBAA6E;EAA7E,iDAA6E;EAA7E,sBAA6E;EAA7E,8BAA6E;EAA7E,uGAAA;AAA6E;AAA7E;EAAA,kBAA6E;EAA7E,0DAA6E;EAA7E,oBAA6E;EAA7E,mDAAA;AAA6E;AAW7E;EAAA,sBAAoD;EAApD,2DAAoD;EAApD,kBAAoD;EAApD,2DAAoD;EAApD,oBAAoD;EAApD,mDAAoD;EAApD,wCAAoD;EAApD,qCAAA;AAAoD;AAGpD;EAAA,sBAAuE;EAAvE,2DAAuE;EAAvE,oBAAuE;EAAvE,kDAAuE;EAAvE,sBAAuE;EAAvE,8BAAuE;EAAvE,uGAAA;AAAuE;AAAvE;EAAA,kBAAuE;EAAvE,2DAAuE;EAAvE,oBAAuE;EAAvE,mDAAA;AAAuE;AAezE,UAAU;AAER;EAAA,kBAAmG;EAAnG,mBAAmG;EAAnG,sBAAmG;EAAnG,sBAAmG;EAAnG,iBAAmG;EAAnG,yBAAmG;EAAnG,oBAAmG;EAAnG,qBAAmG;EAAnG,qBAAmG;EAAnG,wBAAmG;EAAnG,kBAAmG;EAAnG,iBAAmG;EAAnG,gBAAmG;EAAnG,oBAAmG;EAAnG,mDAAA;AAAmG;AAwBrG,SAAS;AAKP;;;;EAAA,WAA+J;EAA/J,uBAA+J;EAA/J,iBAA+J;EAA/J,sBAA+J;EAA/J,4DAA+J;EAA/J,kBAA+J;EAA/J,4DAA+J;EAA/J,kBAA+J;EAA/J,mBAA+J;EAA/J,mBAA+J;EAA/J,sBAA+J;EAA/J,mBAA+J;EAA/J,oBAA+J;EAA/J,gBAA+J;EAA/J,oBAA+J;EAA/J,gDAA+J;EAA/J,yCAA+J;EAA/J,8BAAA;AAA+J;AAA/J;;;;EAAA,sBAA+J;EAA/J,0DAA+J;EAA/J,4BAAA;AAA+J;AAgB/J;EAAA,uBAAiC;EAAjC,cAAiC;EAAjC,gBAAA;AAAiC;AAEnC;IACE,uCAAuC;EACzC;AAOE;;;;;EAAA,sBAA2F;EAA3F,0DAA2F;EAA3F,uCAA2F;EAA3F,oBAA2F;EAA3F,iDAAA;AAA2F;AAA3F;;;;;EAAA,2BAAA;AAA2F;AAA3F;;;;;EAAA,sBAA2F;EAA3F,0DAAA;AAA2F;AAa3F;;EAAA,sBAAoB;EAApB,0DAAA;AAAoB;AAQpB;;;;;EAAA,sBAAgG;EAAhG,yDAAgG;EAAhG,sCAAgG;EAAhG,oBAAgG;EAAhG,gDAAA;AAAgG;AAAhG;;;;;EAAA,0BAAA;AAAgG;AAAhG;;;;;EAAA,sBAAgG;EAAhG,yDAAA;AAAgG;AAelG,qBAAqB;AAGnB;;EAAA,eAA8O;EAA9O,cAA8O;EAA9O,eAA8O;EAA9O,sBAA8O;EAA9O,iBAA8O;EAA9O,sBAA8O;EAA9O,4DAA8O;EAA9O,6BAA8O;EAA9O,oBAA8O;EAA9O,iDAA8O;EAA9O,iCAA8O;EAA9O,yCAA8O;EAA9O,kHAA8O;EAA9O,yCAA8O;EAA9O,8BAA8O;EAA9O,sHAA8O;EAA9O,oHAA8O;EAA9O,uGAA8O;EAA9O,sCAAA;AAA8O;AAA9O;;EAAA,wBAAA;AAA8O;AAA9O;;EAAA,mBAA8O;EAA9O,kBAA8O;EAA9O,4DAAA;AAA8O;AAA9O;;EAAA,sBAAA;AAA8O;AAA9O;;EAAA,qBAAA;AAA8O;AAI9O;EAAA,sBAAoC;EAApC,0DAAoC;EAApC,6BAAoC;IACpC,8PAAA;AADoC;AAIpC;EAAA,sBAAsC;EAAtC,2DAAsC;EAAtC,6BAAsC;IACtC,8PAAA;AADsC;AAItC;EAAA,sBAAoC;EAApC,yDAAoC;EAApC,6BAAoC;IACpC,8PAAA;AADoC;AAIpC;EAAA,sBAAmC;EAAnC,0DAAmC;EAAnC,6BAAmC;IACnC,8PAAA;AADmC;AAInC;EAAA,sBAAoC;EAApC,2DAAoC;EAApC,6BAAoC;IACpC,8PAAA;AADoC;AAIpC;EAAA,sBAAiC;EAAjC,2DAAiC;EAAjC,6BAAiC;IACjC,8PAAA;AADiC;AAIjC;EAAA,sBAAiC;EAAjC,yDAAiC;EAAjC,6BAAiC;IACjC,8PAAA;AADiC;AA8BnC,aAAa;AAEX;EAAA,kBAAA;AAAe;AAGf;EAAA,aAAA;AAAW;AAGX;EAAA,kBAAoF;EAApF,WAAoF;EAApF,mBAAoF;EAApF,gBAAoF;EAApF,sBAAoF;EAApF,kBAAoF;EAApF,4DAAoF;EAApF,YAAoF;EAApF,mBAAoF;EAApF,sBAAoF;EAApF,oBAAoF;EAApF,gDAAoF;EAApF,0EAAoF;EAApF,8FAAoF;EAApF,uGAAoF;IACpF,mHAAmH;AAD/B;AAKpF;;EAAA,aAAuE;EAAvE,mBAAuE;EAAvE,kBAAuE;EAAvE,mBAAuE;EAAvE,mBAAuE;EAAvE,sBAAA;AAAuE;AAAvE;;EAAA,sCAAuE;EAAvE,oBAAuE;EAAvE,iDAAA;AAAuE;AAIvE;EAAA,WAAA;AAAa;AAGf,WAAW;AAKT;EAAA,WAA8B;EAA9B,oCAAA;AAA8B;AAI9B;;EAAA,wBAAiC;EAAjC,6BAAiC;EAAjC,uEAAA;AAAiC;AAKjC;;;EAAA,kBAA6C;EAA7C,mBAA6C;EAA7C,oBAA6C;EAA7C,uBAAA;AAA6C;AAA7C;;;EAAA,gBAAA;AAA6C;AAA7C;;;EAAA,iBAAA;AAA6C;AAI7C;;EAAA,gBAAA;AAAoB;AAGpB;EAAA,wBAAuC;EAAvC,+CAAA;AAAuC;AAiBzC,oBAAoB;AACpB;IACE,cAAc;EAChB;AA5fF;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,iDAAA;AAAmB;AAAnB;EAAA,iDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,uCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,qEAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,4GAAA;AAAmB;AAAnB;EAAA,4DAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,iLAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,sDAAA;AAAmB;;AAsgBnB,sBAAsB;AACtB;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,mCAAmC;AACrC;;AAGE;EAAA,yBAAA;AAAa;;AAGf;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,UAAU;AAER;EAAA,oBAAyD;EAAzD,mDAAA;AAAyD;AAAzD;EAAA,oBAAyD;EAAzD,mDAAA;AAAyD;AAAzD;EAAA,sBAAyD;EAAzD,8BAAyD;EAAzD,uGAAA;AAAyD;;AAIzD;EAAA,kBAA0B;EAA1B,yDAA0B;EAA1B,qBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,wBAAA;AAA0B;;AAK1B;;EAAA,oBAAiB;EAAjB,mDAAA;AAAiB;AAGjB;EAAA,kBAAiB;EAAjB,0DAAA;AAAiB;;AAIjB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;;AAInB;EAAA,kBAAiB;EAAjB,2DAAA;AAAiB;AAGjB;EAAA,kBAAc;EAAd,2DAAA;AAAc;AAGd;EAAA,kBAAgB;EAAhB,0DAAA;AAAgB;AAGhB;EAAA,kBAAiB;EAAjB,yDAAA;AAAiB;;AAGnB,eAAe;AACf;;EAEE,gBAAgB;EAChB,uBAAmD;EAAnD,2BAAmD;EAAnD,oBAAmD;EAAnD,mDAAmD;AACrD;;AAIE;;EAAA,8BAAA;AAA2B;;AAI3B;EAAA,oBAAiB;EAAjB,mDAAA;AAAiB;;AAIjB;EAAA,sBAA+B;EAA/B,yDAA+B;EAA/B,kBAA+B;EAA/B,uDAAA;AAA+B;;AAI/B;EAAA,+BAAA;AAA0B;;AAA1B;EAAA,8BAAA;AAA0B;;AAG5B;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAGE;EAAA,iCAAA;AAAuC;;AAAvC;EAAA,4BAAuC;EAAvC,qBAAA;AAAuC;;AAIvC;EAAA,qBAAkB;EAAlB,iBAAA;AAAkB;;AAGpB,eAAe;AAEb;EAAA,gKAAuC;EAAvC,wJAAuC;EAAvC,iLAAuC;EAAvC,wDAAuC;EAAvC,0BAAuC;EAAvC,sDAAA;AAAuC;AAGvC;EAAA,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,wDAAqC;EAArC,yBAAqC;EAArC,sDAAA;AAAqC;AAIrC;;EAAA,iBAAmC;EAAnC,iBAAmC;EAAnC,+LAAmC;EAAnC,UAAA;AAAmC;AAInC;;EAAA,eAAsC;EAAtC,eAAsC;EAAtC,+LAAsC;EAAtC,UAAA;AAAsC;;AAItC;EAAA,gKAAuC;EAAvC,wJAAuC;EAAvC,iLAAuC;EAAvC,wDAAuC;EAAvC,0BAAuC;EAAvC,sDAAA;AAAuC;AAGvC;EAAA,gKAAsC;EAAtC,wJAAsC;EAAtC,iLAAsC;EAAtC,wDAAsC;EAAtC,0BAAsC;EAAtC,sDAAA;AAAsC;AAItC;;EAAA,iBAAmC;EAAnC,iBAAmC;EAAnC,+LAAmC;EAAnC,UAAA;AAAmC;AAInC;;EAAA,eAAsC;EAAtC,eAAsC;EAAtC,+LAAsC;EAAtC,UAAA;AAAsC;;AAGxC,gBAAgB;AAEd;EAAA,gBAA8D;EAA9D,uBAA8D;EAA9D,6BAA8D;EAA9D,oEAA8D;EAA9D,aAA8D;EAA9D,oBAA8D;EAA9D,mDAAA;AAA8D;;AAGhE,kBAAkB;AAEhB;EAAA,WAAA;AAAa;;;AAIf;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,eAAe;AAEjB;;AADE;EAAA,gCAAA;AAA4B;;AAA5B;EAAA,+BAAA;AAA4B;;AAG9B;EACE,wDAAwD;EACxD,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAElB;;AADE;EAAA,gCAAA;AAA4B;;AAA5B;EAAA,+BAAA;AAA4B;;AAG9B;EACE,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AAEpB;;AADE;EAAA,WAAA;AAA6B;;AAA7B;EAAA,UAAA;AAA6B;;AAG/B;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAE7B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;;;;EAIE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EAEf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,eAAe;EACf,eAAe;EAEf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EAEb,yBAAyB;EAEzB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;AAEE;EAAA,6BAAe;EAAf,+BAAA;AAAe;;AAGjB;EAEE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAGE;EAAA,2BAAkB;EAAlB,4BAAkB;EAAlB,6BAAA;AAAkB;;AAIlB;EAAA,gCAAA;AAA0B;;AAA1B;EAAA,+BAAA;AAA0B;;AAG5B;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,qCAAqC;AACvC;;;;AAIA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,aAAa;EACb,iBAAiB;EACjB;AACF;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EAEzB;AACF;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,0DAA0D;EAC1D,0CAA0C;AAC5C;;AAEA;CACC;AACD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yDAAyD;EACzD;AACF;;;AAGA;EACE,KAAK;EACL,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;;;AAIA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC;AACF;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC;AACF;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE;AACF;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAz5CA;EAAA,QAAA;AA05CA;;;AA15CA;EAAA,kBA05CA;EA15CA,4DAAA;AA05CA;;;AA15CA;EAAA,oBA05CA;EA15CA,iDAAA;AA05CA;;;AA15CA;EAAA,oBA05CA;EA15CA,iDAAA;AA05CA;;;AA15CA;EAAA,oBA05CA;EA15CA,kDAAA;AA05CA;;;AA15CA;EAAA,oBA05CA;EA15CA,iDAAA;AA05CA;;;AA15CA;EAAA,UAAA;AA05CA;;;AA15CA;EAAA,UAAA;AA05CA;;;AA15CA;EAAA,mBAAA;AA05CA;;;AA15CA;EAAA,sBAAA;AA05CA;;;AA15CA;EAAA,oBAAA;AA05CA;;;AA15CA;EAAA,qBAAA;AA05CA;;;AA15CA;EAAA,SAAA;AA05CA;;;AA15CA;EAAA,qBAAA;AA05CA;;;AA15CA;EAAA,mBAAA;AA05CA;;;AA15CA;EAAA,oBAAA;AA05CA;;;AA15CA;EAAA,oBAAA;AA05CA;;;AA15CA;EAAA,uBAAA;AA05CA;;AAk1CA,4q0EAA4q0E","sourcesContent":["\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  html {\n    @apply scroll-smooth;\n  }\n\n  body {\n    @apply bg-[#fafafa];\n  }\n\n  body.dark {\n    @apply bg-[#060818];\n  }\n\n  /* Panel */\n  .panel {\n    @apply relative rounded-md bg-white p-5 shadow ;\n  }\n\n  /* Navbar */\n  .navbar-sticky header,\n  .navbar-floating header {\n    @apply sticky top-0 z-20;\n  }\n  .navbar-floating header {\n    @apply bg-[#fafafa]/90 px-6 pt-4 ;\n  }\n  .navbar-floating header > div > div:first-child {\n    @apply rounded-md;\n  }\n  .horizontal .navbar-floating header > div > div:first-child {\n    @apply rounded-b-none;\n  }\n  .horizontal .navbar-floating header .horizontal-menu {\n    @apply rounded-b-md;\n  }\n\n  /* Sidebar */\n  .sidebar:hover .nav-item > a {\n    @apply w-auto;\n  }\n\n  .sidebar .nav-item > button,\n  .sidebar .nav-item > a {\n    @apply mb-1 flex w-full items-center justify-between overflow-hidden whitespace-nowrap rounded-md p-2.5 text-[#506690] hover:bg-[#000]/[0.08] hover:text-black ;\n  }\n  .sidebar .nav-item > button.active,\n  .sidebar .nav-item > a.active {\n    @apply bg-[#000]/[0.08] text-black ;\n  }\n\n\n\n  .sidebar ul.sub-menu li button,\n  .sidebar ul.sub-menu li a {\n    @apply flex w-full items-center px-9 py-2.5 before:h-0.5 before:w-2 before:rounded before:bg-gray-300 hover:bg-gray-100\n    hover:text-primary hover:before:!bg-primary ltr:before:mr-2 rtl:before:ml-2 ;\n  }\n  .sidebar ul.sub-menu li button.active,\n  .sidebar ul.sub-menu li a.active {\n    @apply text-primary before:bg-primary;\n  }\n\n  .sidebar .nav-item a div:first-child svg,\n  .sidebar .nav-item button div:first-child svg {\n    @apply h-5 w-5 text-black/50 ;\n  }\n\n  .main-container .main-content {\n    @apply transition-all duration-300 lg:ltr:ml-[260px] lg:rtl:mr-[260px];\n  }\n\n  /* Horizontal layouts */\n  .horizontal .horizontal-menu {\n    @apply hidden shadow-md lg:flex;\n  }\n  .horizontal .horizontal-logo {\n    @apply flex;\n  }\n  .horizontal .main-container .main-content {\n    @apply ltr:ml-0 rtl:mr-0;\n  }\n  .horizontal .sidebar {\n    @apply ltr:-left-[260px] rtl:-right-[260px];\n  }\n  .horizontal.toggle-sidebar .sidebar {\n    @apply ltr:left-0 rtl:right-0 lg:ltr:-left-[260px] lg:rtl:-right-[260px];\n  }\n\n  .horizontal .nav-item a div:first-child svg {\n    @apply h-5 w-5 text-black/50 ;\n  }\n\n  .horizontal .dark .nav-item a div:first-child svg,\n  .dark.horizontal .nav-item a div:first-child svg {\n    @apply text-white/50;\n  }\n\n  .horizontal-menu .nav-link {\n    @apply flex items-center rounded-lg px-2 py-2.5 hover:bg-[#000]/[0.08] hover:text-black  xl:px-4;\n  }\n\n  .horizontal-menu .nav-link.active {\n    @apply bg-[#000]/[0.08] text-black ;\n  }\n\n  .horizontal-menu ul.sub-menu {\n    @apply absolute top-full z-20 hidden min-w-[180px] rounded bg-white p-0 py-2 text-dark shadow ;\n  }\n\n  .horizontal-menu ul.sub-menu a {\n    @apply flex items-center justify-between px-4 py-2 hover:bg-gray-100 hover:text-primary ;\n  }\n\n  .horizontal-menu ul.sub-menu a.active {\n    @apply bg-gray-100 text-primary ;\n  }\n\n  .horizontal-menu > li.nav-item:hover > ul.sub-menu,\n  .horizontal-menu > li.nav-item > ul.sub-menu > li:hover > ul {\n    @apply block;\n  }\n\n  /* Vertical layouts */\n  .vertical.toggle-sidebar .horizontal-logo,\n  .vertical.toggle-sidebar .collapse-icon {\n    @apply flex;\n  }\n  .vertical.toggle-sidebar .main-container .main-content {\n    @apply ltr:ml-0 rtl:mr-0;\n  }\n  .vertical .sidebar {\n    @apply ltr:-left-[260px] rtl:-right-[260px] lg:ltr:left-0 lg:rtl:right-0;\n  }\n  .vertical.toggle-sidebar .sidebar {\n    @apply ltr:left-0 rtl:right-0 lg:ltr:-left-[260px] lg:rtl:-right-[260px];\n  }\n\n  /* Collapsible vertical layouts */\n  .collapsible-vertical .sidebar {\n    @apply hover:w-[260px] ltr:-left-[260px] rtl:-right-[260px] lg:w-[70px] lg:ltr:left-0 lg:rtl:right-0;\n  }\n  .collapsible-vertical.toggle-sidebar .sidebar {\n    @apply ltr:left-0 rtl:right-0;\n  }\n  .collapsible-vertical.toggle-sidebar .sidebar {\n    @apply lg:w-[260px];\n  }\n  .collapsible-vertical.toggle-sidebar .sidebar .nav-item > a {\n    @apply w-auto;\n  }\n  .collapsible-vertical.toggle-sidebar .main-content {\n    @apply lg:w-[calc(100%-260px)] lg:ltr:ml-[260px] lg:rtl:mr-[260px];\n  }\n\n  .collapsible-vertical .sidebar .sub-menu {\n    @apply lg:hidden;\n  }\n  .collapsible-vertical .sidebar:hover .sub-menu,\n  .collapsible-vertical .sidebar:hover .sub-menu.recent-submenu,\n  .collapsible-vertical.toggle-sidebar .sidebar .sub-menu {\n    @apply block;\n  }\n  .collapsible-vertical .main-content {\n    @apply lg:w-[calc(100%-70px)] lg:ltr:ml-[70px] lg:rtl:mr-[70px];\n  }\n  .collapsible-vertical .sidebar .collapse-icon,\n  .collapsible-vertical .main-logo > span {\n    @apply transition-opacity duration-300 lg:opacity-0;\n  }\n  .collapsible-vertical .sidebar:hover .collapse-icon,\n  .collapsible-vertical.toggle-sidebar .collapse-icon,\n  .collapsible-vertical .sidebar:hover .main-logo > span,\n  .collapsible-vertical.toggle-sidebar .main-logo > span {\n    @apply duration-500 lg:opacity-100;\n  }\n  .collapsible-vertical.toggle-sidebar .sidebar .collapse-icon {\n    @apply flex rotate-0;\n  }\n  .collapsible-vertical .sidebar:hover .collapse-icon {\n    @apply flex rotate-180;\n  }\n  .collapsible-vertical .sidebar ul > h2 span {\n    @apply hidden whitespace-nowrap;\n  }\n  .collapsible-vertical .sidebar ul > h2 svg {\n    @apply block;\n  }\n  .collapsible-vertical .sidebar:hover ul > h2 span,\n  .collapsible-vertical.toggle-sidebar .sidebar ul > h2 span {\n    @apply inline;\n  }\n  .collapsible-vertical .sidebar:hover ul > h2 svg,\n  .collapsible-vertical.toggle-sidebar .sidebar ul > h2 svg {\n    @apply hidden;\n  }\n\n  /* boxed-layout */\n  .boxed-layout {\n    @apply mx-auto max-w-[1400px];\n  }\n\n  .boxed-layout.vertical .sidebar,\n  .boxed-layout.collapsible-vertical .sidebar {\n    @apply overflow-hidden lg:ltr:left-auto lg:rtl:right-auto;\n  }\n\n  .boxed-layout.vertical.toggle-sidebar .sidebar {\n    @apply lg:w-0;\n  }\n\n  /* Buttons */\n  .btn {\n    @apply relative flex items-center justify-center rounded-md border px-5 py-2 text-sm font-semibold shadow-[0_10px_20px_-10px] outline-none transition duration-300 hover:shadow-none;\n  }\n  .btn-lg {\n    @apply px-7 py-2.5 text-base;\n  }\n  .btn-sm {\n    @apply px-2.5 py-1.5 text-xs;\n  }\n  .btn[disabled] {\n    @apply cursor-not-allowed opacity-60;\n  }\n\n  .btn-primary {\n    @apply border-primary bg-primary text-white shadow-primary/60;\n  }\n  .btn-outline-primary {\n    @apply border-primary text-primary shadow-none hover:bg-primary hover:text-white;\n  }\n\n  .btn-secondary {\n    @apply border-secondary bg-secondary text-white shadow-secondary/60;\n  }\n  .btn-outline-secondary {\n    @apply border-secondary text-secondary shadow-none hover:bg-secondary hover:text-white;\n  }\n\n  .btn-success {\n    @apply border-success bg-success text-white shadow-success/60;\n  }\n  .btn-outline-success {\n    @apply border-success text-success shadow-none hover:bg-success hover:text-white;\n  }\n\n  .btn-danger {\n    @apply border-danger bg-danger text-white shadow-danger/60;\n  }\n  .btn-outline-danger {\n    @apply border-danger text-danger shadow-none hover:bg-danger hover:text-white;\n  }\n\n  .btn-dlight {\n    @apply border-dlight bg-dlight text-white shadow-dlight/60;\n  }\n\n  .btn-outline-danger {\n    @apply border-danger text-danger shadow-none hover:bg-danger hover:text-white;\n  }\n\n  .btn-outline-dlight {\n    @apply border-dlight text-dlight shadow-none hover:bg-dlight hover:text-white;\n  }\n\n  .btn-warning {\n    @apply border-warning bg-warning text-white shadow-warning/60;\n  }\n  .btn-outline-warning {\n    @apply border-warning text-warning shadow-none hover:bg-warning hover:text-white;\n  }\n\n  .btn-info {\n    @apply border-info bg-info text-white shadow-info/60;\n  }\n  .btn-outline-info {\n    @apply border-info text-info shadow-none hover:bg-info hover:text-white;\n  }\n\n  .btn-dark {\n    @apply border-dark bg-dark text-white shadow-dark/60;\n  }\n\n  .btn-outline-dark {\n    @apply border-dark text-dark shadow-none hover:bg-dark hover:text-white;\n  }\n\n  .btn-gradient {\n    @apply bg-gradient-to-r from-[#EF1262] to-[#4361EE] text-white hover:from-[#4361EE] hover:to-[#EF1262];\n  }\n\n  /* Badge */\n  .badge {\n    @apply relative my-1 rounded border border-transparent px-2 py-0.5 text-xs font-semibold text-white;\n  }\n  .badge-outline-primary {\n    @apply border-primary text-primary hover:bg-primary-light ;\n  }\n  .badge-outline-secondary {\n    @apply border-secondary text-secondary hover:bg-secondary-light ;\n  }\n  .badge-outline-success {\n    @apply border-success text-success hover:bg-success-light ;\n  }\n  .badge-outline-danger {\n    @apply border-danger text-danger hover:bg-danger-light ;\n  }\n  .badge-outline-warning {\n    @apply border-warning text-warning hover:bg-warning-light ;\n  }\n  .badge-outline-info {\n    @apply border-info text-info hover:bg-info-light ;\n  }\n  .badge-outline-dark {\n    @apply border-dark text-dark hover:bg-dark-light ;\n  }\n\n  /* Form */\n  .form-input,\n  .form-textarea,\n  .form-select,\n  .form-multiselect {\n    @apply w-full rounded-md border border-[#e0e6ed] bg-white px-4 py-2 text-sm font-semibold text-black !outline-none focus:border-primary focus:ring-transparent ;\n  }\n\n  .form-input-lg,\n  .form-textarea-lg,\n  .form-select-lg,\n  .form-multiselect-lg {\n    @apply py-2.5 text-base;\n  }\n  .form-input-sm,\n  .form-textarea-sm,\n  .form-select-sm,\n  .form-multiselect-sm {\n    @apply py-1.5 text-xs;\n  }\n  label {\n    @apply mb-1.5 block font-semibold;\n  }\n  [dir='rtl'] select {\n    background-position: left 0.5rem center;\n  }\n\n  .has-error .form-input,\n  .has-error .form-textarea,\n  .has-error .form-select,\n  .has-error .form-multiselect,\n  .has-error .multiselect__tags {\n    @apply border-danger bg-danger/[0.08] text-danger placeholder-danger/70 focus:border-danger;\n  }\n  .has-error .form-label,\n  .has-error .form-help,\n  .has-error .form-icon,\n  .has-error .multiselect__placeholder {\n    @apply text-danger;\n  }\n  .has-error .multiselect__input {\n    @apply bg-[#F7ECF0] !placeholder-danger/70;\n  }\n  .has-error .multiselect__tags:hover,\n  .has-error .form-checkbox {\n    @apply border-danger;\n  }\n\n  .has-success .form-input,\n  .has-success .form-textarea,\n  .has-success .form-select,\n  .has-success .form-multiselect,\n  .has-success .multiselect__tags {\n    @apply border-success bg-success/[0.08] text-success placeholder-success/70 focus:border-success;\n  }\n  .has-success .form-label,\n  .has-success .form-help,\n  .has-success .form-icon,\n  .has-success .multiselect__placeholder {\n    @apply text-success;\n  }\n  .has-success .multiselect__input {\n    @apply bg-[#F7ECF0] !placeholder-success/70;\n  }\n  .has-success .multiselect__tags:hover {\n    @apply border-success;\n  }\n\n  /* checkbox & radio */\n  .form-radio,\n  .form-checkbox {\n    @apply h-5 w-5 cursor-pointer rounded border-2 border-[#e0e6ed] bg-transparent text-primary !shadow-none !outline-none !ring-0 !ring-offset-0 checked:bg-[length:90%_90%] disabled:cursor-not-allowed disabled:bg-[#eee] ltr:mr-1.5 rtl:ml-1.5;\n  }\n\n  .form-checkbox.outline-primary:checked {\n    @apply border-primary bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%234361ee' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-secondary:checked {\n    @apply border-secondary bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23805dca' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-success:checked {\n    @apply border-success bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%2300ab55' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-danger:checked {\n    @apply border-danger bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e7515a' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-warning:checked {\n    @apply border-warning bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e2a03f' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-info:checked {\n    @apply border-info bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%232196f3' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n  .form-checkbox.outline-dark:checked {\n    @apply border-dark bg-transparent;\n    background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%233b3f5c' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n  }\n\n  .form-radio {\n    @apply rounded-full;\n  }\n\n  .form-radio.outline-primary:checked {\n    @apply border-primary bg-transparent bg-none;\n  }\n  .form-radio.outline-secondary:checked {\n    @apply border-secondary bg-transparent bg-none;\n  }\n  .form-radio.outline-success:checked {\n    @apply border-success bg-transparent bg-none;\n  }\n  .form-radio.outline-danger:checked {\n    @apply border-danger bg-transparent bg-none;\n  }\n  .form-radio.outline-warning:checked {\n    @apply border-warning bg-transparent bg-none;\n  }\n  .form-radio.outline-info:checked {\n    @apply border-info bg-transparent bg-none;\n  }\n  .form-radio.outline-dark:checked {\n    @apply border-dark bg-transparent bg-none;\n  }\n\n  /* dropdown */\n  .dropdown {\n    @apply relative;\n  }\n  .dropdown > button {\n    @apply flex;\n  }\n  .dropdown ul {\n    @apply absolute z-10 mt-1 min-w-[120px] rounded bg-white p-0 py-2 text-black shadow ;\n    /* @apply my-1 min-w-[120px] rounded bg-white p-0 py-2 shadow dark:bg-[#1b2e4b]  text-black dark:text-white-dark; */\n  }\n  .dropdown ul li > a,\n  .dropdown ul li > button {\n    @apply flex items-center px-4 py-2 hover:bg-dlight/10 hover:text-dlight;\n  }\n\n  .dropdown ul li > button {\n    @apply w-full;\n  }\n\n  /* tables */\n  .table-responsive {\n    @apply overflow-auto;\n  }\n  table {\n    @apply w-full !border-collapse;\n  }\n  table thead tr,\n  table tfoot tr {\n    @apply border-b-0 !bg-[#f6f8fa]  ;\n  }\n  table thead tr th,\n  table tfoot tr th,\n  table tbody tr td {\n    @apply px-4 py-3 ltr:text-left rtl:text-right;\n  }\n  table thead tr th,\n  table tfoot tr th {\n    @apply font-semibold;\n  }\n  table tbody tr {\n    @apply border-b !border-white-light/40 ;\n  }\n  table.table-hover tbody tr {\n    @apply hover:!bg-white-light/20 ;\n  }\n  table.table-striped tbody tr:nth-child(odd) {\n    @apply !bg-white-light/20 ;\n  }\n\n  table.dataTable-table tbody tr th,\n  table.dataTable-table tbody tr td {\n    @apply border-b border-white-light/40 px-4 py-3 ltr:text-left rtl:text-right ;\n  }\n  table.dataTable-table tbody tr:last-child td {\n    @apply border-b-0;\n  }\n\n  /* code hightlight */\n  pre {\n    direction: ltr;\n  }\n\n  .accordion-content {\n    @apply overflow-hidden;\n    /* max-height: 0;\n    overflow: hidden;\n    transition: max-height 350ms ease-out; */\n  }\n}\n\n/* perfect scrollbar */\n.ng-scrollbar {\n  --scrollbar-size: 6px !important;\n  --scrollbar-thumb-color: #dddddd !important;\n  --scrollbar-padding: 0px !important;\n}\n\n.collapsible-vertical .sidebar .ng-scroll-content {\n  @apply !block;\n}\n\n.sidebar .ng-scrollbar {\n  --scrollbar-padding: 2px !important;\n}\n\n.dark .ng-scrollbar {\n  --scrollbar-thumb-color: #2d334c !important;\n}\n\n/* swal2 */\n.swal2-container .swal2-close {\n  @apply text-white hover:text-dark-light focus:shadow-none;\n}\n\n.swal2-container .swal2-popup.swal2-toast {\n  @apply bg-dark px-5 py-2.5;\n}\n\n.swal2-popup.swal2-toast .swal2-title,\n.swal2-container .swal2-popup.swal2-toast .swal2-html-container {\n  @apply text-white;\n}\n.swal2-container .swal2-popup.swal2-toast.color-primary {\n  @apply bg-primary;\n}\n\n.swal2-container .swal2-popup.swal2-toast.color-secondary {\n  @apply bg-secondary;\n}\n\n.swal2-container .swal2-popup.swal2-toast.color-warning {\n  @apply bg-warning;\n}\n.swal2-container .swal2-popup.swal2-toast.color-info {\n  @apply bg-info;\n}\n.swal2-container .swal2-popup.swal2-toast.color-danger {\n  @apply bg-danger;\n}\n.swal2-container .swal2-popup.swal2-toast.color-success {\n  @apply bg-success;\n}\n\n/* apex chart */\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light,\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light {\n  box-shadow: none;\n  @apply border-[#050717cc] bg-[#050717cc] text-white;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas .apexcharts-xaxistooltip-bottom:after {\n  @apply border-b-[#050717cc];\n}\n\n.apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active {\n  @apply text-white;\n}\n\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  @apply border-dark bg-[#060818];\n}\n\n.apexcharts-legend-series {\n  @apply ltr:!mr-2 rtl:!ml-2;\n}\n\n.dark .apexcharts-title-text {\n  fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-text.apexcharts-xaxis-label,\n.dark .apexcharts-canvas .apexcharts-text.apexcharts-yaxis-label {\n  fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-text,\n.dark .apexcharts-canvas .apexcharts-text {\n  fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-legend-text {\n  color: #e0e6ed !important;\n}\n\n.dark .apexcharts-canvas .apexcharts-radialbar-track.apexcharts-track .apexcharts-radialbar-area {\n  stroke: #191e3a;\n}\n.dark .apexcharts-canvas .apexcharts-series-markers.apexcharts-series-bubble .apexcharts-marker {\n  stroke: #191e3a;\n}\n\n.dark .apexcharts-canvas .apexcharts-pie-label,\n.dark .apexcharts-canvas .apexcharts-datalabel,\n.dark .apexcharts-canvas .apexcharts-datalabel-label,\n.dark .apexcharts-canvas .apexcharts-datalabel-value {\n  fill: #bfc9d4;\n}\n\n.dark .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {\n  box-shadow: none;\n}\n\n.apexcharts-canvas .apexcharts-legend-marker {\n  @apply ltr:!mr-1.5 rtl:!mr-0 rtl:ml-1.5;\n}\n\n[dir='rtl'] .apexcharts-tooltip-marker {\n  @apply ml-2.5 mr-0;\n}\n\n/* Animations */\n.slide-down-enter-active {\n  @apply transition duration-100 ease-out;\n}\n.slide-down-leave-active {\n  @apply transition duration-75 ease-in;\n}\n.slide-down-enter-from,\n.slide-down-leave-to {\n  @apply scale-95 transform opacity-0;\n}\n.slide-down-enter-to,\n.slide-down-leave-from {\n  @apply scale-100 transform opacity-100;\n}\n\n.modal-fade-enter-active {\n  @apply transition duration-300 ease-out;\n}\n.modal-fade-leave-active {\n  @apply transition duration-200 ease-in;\n}\n.modal-fade-enter-from,\n.modal-fade-leave-to {\n  @apply scale-95 transform opacity-0;\n}\n.modal-fade-enter-to,\n.modal-fade-leave-from {\n  @apply scale-100 transform opacity-100;\n}\n\n/* highlightjs */\npre code.hljs {\n  @apply overflow-x-auto rounded-md !bg-[#191e3a] p-4 text-white;\n}\n\n/* ngx-scrollbar */\n.ng-scroll-viewport {\n  @apply w-full;\n}\n\n\n.small-box-shadow {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\nbody.swal2-toast-shown .swal2-container.toast {\n  width: 400px;\n}\n\n.swal2-popup {\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px !important;\n  box-sizing: border-box;\n}\n\n.dark .swal2-popup {\n  background: #0e1726;\n}\n\n.dark .swal2-popup .swal2-title {\n  color: #888ea8;\n}\n\n.swal2-popup .swal2-title {\n  display: block;\n  margin: 0px !important;\n  width: 100%;\n  color: #3b3f5c;\n  font-size: 24px;\n  @apply ltr:!pr-10 rtl:!pl-10;\n}\n\n.swal2-popup .swal2-styled {\n  box-shadow: 0px 5px 20px 0 rgba(0, 0, 0, 0.1) !important;\n  letter-spacing: 1px;\n  font-size: 14px !important;\n  line-height: 20px !important;\n  transition: all 0.3s ease-out;\n  -webkit-transition: all 0.3s ease-out;\n  margin: 0 5px;\n  padding: 8px 20px;\n  border-radius: 6px;\n}\n\n.swal2-popup .swal2-styled.swal2-cancel {\n  background-color: #fff !important;\n  color: #4361ee;\n  border: 1px solid #e8e8e8;\n  box-shadow: none;\n  padding: 7px 20px;\n}\n\n.dark .swal2-popup .swal2-styled.swal2-cancel {\n  background-color: #3b3f5c !important;\n  color: #e0e6ed;\n  border-color: #3b3f5c;\n}\n\n.swal2-popup .swal2-styled.swal2-confirm {\n  background-color: #4361ee;\n}\n\n.swal2-popup .swal2-styled.swal2-confirm:focus {\n  box-shadow: none !important;\n}\n\n.swal2-popup .swal2-html-container {\n  margin: 0 !important;\n  color: #e95f2b;\n  font-weight: 300;\n  @apply ltr:!pr-10 rtl:!pl-10;\n}\n\n.swal2-popup .swal2-close {\n  position: absolute;\n  top: 16px;\n  transition: color 0.1s ease-out;\n  font-family: serif;\n  @apply ltr:right-4 rtl:left-4;\n}\n\n.dark .swal2-popup .swal2-close {\n  color: #888ea8;\n}\n\n.swal2-popup.swal2-toast {\n  flex-direction: row;\n  align-items: center;\n  width: auto !important;\n  box-shadow: 0 0 0.625em #d9d9d9;\n  padding: 2em;\n  overflow-y: hidden;\n  display: flex !important;\n}\n\n.swal2-popup.swal2-toast.swal2-show {\n  -webkit-animation: showSweetToast 0.5s;\n  animation: showSweetToast 0.5s;\n}\n\n.swal2-popup pre {\n  color: #009688;\n}\n\n.swal2-icon {\n  position: relative;\n  box-sizing: content-box;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: 1.25em auto 1.875em;\n  border: 0.25em solid transparent;\n  border-radius: 50%;\n  border-color: #000;\n  font-family: inherit;\n  line-height: 5em;\n  cursor: default;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.sweet-alerts .swal2-icon:not(.swal2-error):not(.swal2-success) {\n  width: 2em !important;\n  line-height: 119px !important;\n  height: 2em !important;\n  margin: 0.25em auto 0.875em !important;\n}\n\n.swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n  height: 3px !important;\n}\n\n.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n  width: 16px !important;\n  top: 11px !important;\n}\n\n.swal2-icon.swal2-error {\n  border-color: #e7515a !important;\n  border: 4px solid #f1f2f3 !important;\n  box-shadow: 0px 3px 25px 0px rgb(113 106 202 / 20%);\n}\n\n.swal2-icon.swal2-warning {\n  color: #fb4 !important;\n  border: 4px solid #f1f2f3 !important;\n  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);\n  text-align: center;\n}\n\n.sweet-alerts .swal2-icon.swal2-warning,\n.sweet-alerts .swal2-icon.swal2-question,\n.sweet-alerts .swal2-icon.swal2-info {\n  font-size: 60px;\n  line-height: 80px;\n}\n\n.swal2-popup.swal2-toast .swal2-icon {\n  height: 26px !important;\n  width: 26px !important;\n  min-width: 26px !important;\n  border-width: 2px !important;\n}\n\n.swal2-icon.swal2-info {\n  color: #4361ee !important;\n  border: 4px solid #f1f2f3 !important;\n  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);\n  text-align: center;\n}\n\n.swal2-icon.swal2-question {\n  color: #805dca !important;\n  border: solid 4px #ebedf2 !important;\n  border-color: none !important;\n  text-align: center;\n  box-shadow: 0px 3px 25px 0px rgba(113, 106, 202, 0.2);\n  text-align: center;\n}\n\n.dark .swal2-icon.swal2-question,\n.dark .swal2-icon.swal2-info,\n.dark .swal2-icon.swal2-warning,\n.dark .swal2-icon.swal2-error {\n  border-color: #888ea8 !important;\n  box-shadow: none !important;\n}\n\n.swal2-iconswal2-success [class^='swal2-success-line'][class$='tip'] {\n  top: 2.875em;\n  left: 0.875em;\n  width: 1.5625em;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.swal2-icon.swal2-success swal2-success [class^='swal2-success-line'][class$='long'] {\n  top: 2.375em;\n  right: 0.5em;\n  width: 2.9375em;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n  position: absolute;\n  top: 0.5em;\n  left: 1.625em;\n  width: 0.4375em;\n  height: 5.625em;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  z-index: 1;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  position: absolute;\n  top: -0.25em;\n  left: -0.25em;\n  width: 100%;\n  height: 100%;\n  border: 0.25em solid rgba(165, 220, 134, 0.3);\n  border-radius: 50%;\n  z-index: 2;\n  box-sizing: content-box;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n  top: -0.6875em;\n  left: 1.875em;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 0 3.75em;\n  transform-origin: 0 3.75em;\n  border-radius: 0 7.5em 7.5em 0;\n}\n\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: #25d5e4 !important;\n}\n\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {\n  background: #ebedf2 !important;\n}\n\n.dark .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {\n  background: #3b3f5c !important;\n  color: #888ea8 !important;\n}\n\n.dark .swal2-progress-steps .swal2-progress-step {\n  color: #e0e6ed;\n}\n\n.sweet-alerts .swal2-icon-content {\n  font-size: 5.75rem !important;\n}\n.swal2-icon-content {\n  @apply !text-xl;\n}\n\n.swal2-show {\n  -webkit-animation: swal2-show 0.3s;\n  animation: swal2-show 0.3s;\n}\n\n.swal2-modal.background-modal .swal2-title {\n  color: #fff !important;\n}\n\n.dark .swal2-input {\n  background-color: #1b2e4b;\n  border-color: #253b5c;\n  color: #888ea8;\n}\n\n.dark .swal2-footer {\n  border-color: #888ea8;\n}\n\n.swal2-image {\n  margin-bottom: 32px !important;\n}\n\n.sweet-alerts.swal2-popup .swal2-html-container {\n  @apply !mt-4 !px-0;\n}\n\n.sweet-alerts.swal2-popup .swal2-title {\n  @apply ltr:!pr-6 rtl:!pl-6;\n}\n\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {\n  width: 24px !important;\n  height: 26px !important;\n}\n\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n  top: -0.8em;\n  left: -0.5em;\n  transform: rotate(-45deg);\n  transform-origin: 2em 2em;\n  border-radius: 4em 0 0 4em;\n}\n\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='tip'] {\n  top: 15px !important;\n  left: 3px !important;\n  width: 9px !important;\n}\n\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='long'] {\n  top: 14px !important;\n  right: 2px !important;\n  width: 16px !important;\n}\n\n.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {\n  width: 26px !important;\n  height: 26px !important;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  position: absolute;\n  z-index: 2 !important;\n  top: -2px !important;\n  left: -2px !important;\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  border: 2px solid rgba(165, 220, 134, 0.3);\n  border-radius: 50%;\n}\n\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n  transform-origin: 26px 26px !important;\n  border-radius: 2em 0 0 2em !important;\n}\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {\n  width: 20px !important;\n  height: 43px !important;\n}\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='tip'] {\n  top: 15px !important;\n  left: 4px !important;\n  width: 8px !important;\n}\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'] {\n  height: 3px !important;\n}\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='long'] {\n  top: 12px !important;\n  right: 3px !important;\n  width: 16px !important;\n}\n.swal2-icon.swal2-success .swal2-success-ring {\n  top: -2px !important;\n  left: -2px !important;\n  border: 3px solid rgba(165, 220, 134, 0.3) !important;\n}\n.swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n  border-radius: 0 2em 2em 0 !important;\n}\n\n\n\n.swal2-popup {\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px!important;\n  box-sizing: border-box\n}\n\n.dark .swal2-popup {\n  background: #0e1726\n}\n\n.dark .swal2-popup .swal2-title {\n  color: #888ea8\n}\n\n.swal2-popup .swal2-title {\n  display: block;\n  margin: 0!important;\n  width: 100%;\n  color: #3b3f5c;\n  font-size: 24px\n}\n\n.swal2-popup .swal2-title:where([dir=ltr],[dir=ltr] *) {\n  padding-right: 2.5rem!important\n}\n\n.swal2-popup .swal2-title:where([dir=rtl],[dir=rtl] *) {\n  padding-left: 2.5rem!important\n}\n\n.swal2-popup .swal2-styled {\n  box-shadow: 0 5px 20px 0 #0000001a!important;\n  letter-spacing: 1px;\n  font-size: 14px!important;\n  line-height: 20px!important;\n  transition: all .3s ease-out;\n  -webkit-transition: all .3s ease-out;\n  margin: 0 5px;\n  padding: 8px 20px;\n  border-radius: 6px\n}\n\n.swal2-popup .swal2-styled.swal2-cancel {\n  background-color: #fff!important;\n  color: #4361ee;\n  border: 1px solid #e8e8e8;\n  box-shadow: none;\n  padding: 7px 20px\n}\n\n.dark .swal2-popup .swal2-styled.swal2-cancel {\n  background-color: #3b3f5c!important;\n  color: #e0e6ed;\n  border-color: #3b3f5c\n}\n\n.swal2-popup .swal2-styled.swal2-confirm {\n  background-color: #4361ee\n}\n\n.swal2-popup .swal2-styled.swal2-confirm:focus {\n  box-shadow: none!important\n}\n\n.swal2-popup .swal2-html-container {\n  margin: 0!important;\n  color: #e95f2b;\n  font-weight: 300\n}\n\n.swal2-popup .swal2-html-container:where([dir=ltr],[dir=ltr] *) {\n  padding-right: 2.5rem!important\n}\n\n.swal2-popup .swal2-html-container:where([dir=rtl],[dir=rtl] *) {\n  padding-left: 2.5rem!important\n}\n\n.swal2-popup .swal2-close {\n  position: absolute;\n  top: 16px;\n  transition: color .1s ease-out;\n  font-family: serif\n}\n\n.swal2-popup .swal2-close:where([dir=ltr],[dir=ltr] *) {\n  right: 1rem\n}\n\n.swal2-popup .swal2-close:where([dir=rtl],[dir=rtl] *) {\n  left: 1rem\n}\n\n.dark .swal2-popup .swal2-close {\n  color: #888ea8\n}\n\n.swal2-popup.swal2-toast {\n  flex-direction: row;\n  align-items: center;\n  width: auto!important;\n  box-shadow: 0 0 .625em #d9d9d9;\n  padding: 2em;\n  overflow-y: hidden;\n  display: flex!important\n}\n\n.swal2-popup.swal2-toast.swal2-show {\n  animation: showSweetToast .5s\n}\n\n.swal2-popup pre {\n  color: #009688\n}\n\n.swal2-icon {\n  position: relative;\n  box-sizing: initial;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: 1.25em auto 1.875em;\n  border-radius: 50%;\n  border: .25em solid #000;\n  font-family: inherit;\n  line-height: 5em;\n  cursor: default;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none\n}\n\n.swal2-icon:not(.swal2-error):not(.swal2-success) {\n  width: 2em!important;\n  line-height: 119px!important;\n  height: 2em!important;\n  margin: .25em auto .875em!important\n}\n\n.swal2-icon.swal2-error {\n  border: 5px solid #f1f2f3!important;\n  box-shadow: 0 3px 25px 0 #716aca33\n}\n\n.swal2-icon.swal2-warning {\n  color: #fb4!important\n}\n\n.swal2-icon.swal2-info,.swal2-icon.swal2-warning {\n  border: 5px solid #f1f2f3!important;\n  box-shadow: 0 3px 25px 0 #716aca33;\n  font-size: 60px;\n  line-height: 80px;\n  text-align: center\n}\n\n.swal2-icon.swal2-info {\n  color: #4361ee!important\n}\n\n.swal2-icon.swal2-question {\n  color: #805dca!important;\n  border-style: solid;\n  border-width: 4px!important;\n  border-color: #0000!important;\n  box-shadow: 0 3px 25px 0 #716aca33;\n  font-size: 60px;\n  line-height: 80px;\n  text-align: center\n}\n\n.dark .swal2-icon.swal2-error,.dark .swal2-icon.swal2-info,.dark .swal2-icon.swal2-question,.dark .swal2-icon.swal2-warning {\n  border-color: #888ea8!important;\n  box-shadow: none!important\n}\n\n.swal2-iconswal2-success [class^=swal2-success-line][class$=tip] {\n  top: 2.875em;\n  left: .875em;\n  width: 1.5625em;\n  transform: rotate(45deg)\n}\n\n.swal2-icon.swal2-success swal2-success [class^=swal2-success-line][class$=long] {\n  top: 2.375em;\n  right: .5em;\n  width: 2.9375em;\n  transform: rotate(-45deg)\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n  position: absolute;\n  top: .5em;\n  left: 1.625em;\n  width: .4375em;\n  height: 5.625em;\n  transform: rotate(-45deg);\n  z-index: 1\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  position: absolute;\n  top: -.25em;\n  left: -.25em;\n  width: 100%;\n  height: 100%;\n  border: .25em solid #a5dc864d;\n  border-radius: 50%;\n  z-index: 2;\n  box-sizing: initial\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right] {\n  top: -.6875em;\n  left: 1.875em;\n  transform: rotate(-45deg);\n  transform-origin: 0 3.75em;\n  border-radius: 0 7.5em 7.5em 0\n}\n\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: #25d5e4!important\n}\n\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step {\n  background: #ebedf2!important\n}\n\n.dark .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step {\n  background: #3b3f5c!important;\n  color: #888ea8!important\n}\n\n.dark .swal2-progress-steps .swal2-progress-step {\n  color: #e0e6ed\n}\n\n.swal2-icon-content {\n  font-size: 5.75rem!important\n}\n\n.swal2-show {\n  animation: swal2-show .3s\n}\n\n.swal2-modal.background-modal .swal2-title {\n  color: #fff!important\n}\n\n.dark .swal2-input {\n  background-color: #1b2e4b;\n  border-color: #253b5c;\n  color: #888ea8\n}\n\n.dark .swal2-footer {\n  border-color: #888ea8\n}\n\n.swal2-image {\n  margin-bottom: 32px!important\n}\n\n.sweet-alerts.swal2-popup .swal2-html-container {\n  margin-top: 1rem!important;\n  padding-left: 0!important;\n  padding-right: 0!important\n}\n\n.sweet-alerts.swal2-popup .swal2-title:where([dir=ltr],[dir=ltr] *) {\n  padding-right: 1.5rem!important\n}\n\n.sweet-alerts.swal2-popup .swal2-title:where([dir=rtl],[dir=rtl] *) {\n  padding-left: 1.5rem!important\n}\n.swal2-popup .swal2-styled.swal2-confirm {\n  background-color: #4361ee!important;\n}\n\n.box-shadow-pop {\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px!important;\n  transition: all 0.2s ease-in-out!important;\n}\n\n.box-shadow-pop:hover {\n box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 10px 5px!important\n}\n\n.form-input-focus {\n  transition: 0.4s ease-in-out;\n}\n\n.form-input-focus:focus {\n  box-shadow: 1px 0 10px 1px rgba(255,70,30, 0.1)!important;\n  border:1px solid rgba(255,70,30, 1)!important\n}\n\n\n.stacked{\n  top:0;\n  transition: top ease 0.3s;\n  position:relative;\n  right:2px;\n}\n.stacked:hover {\n  top: -10px;\n}\n.avatar-box{\n  display:table-cell;\n  vertical-align:middle;\n\n}\n.avatar {\n  display: table-cell;\n  vertical-align:middle;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 600;\n  color: #fff;\n}\n\n\n.avatar-sm{\n  width:2vw;\n  height:2vw;\n  font-size:1vw;\n}\n\n\n\n.color-picker {\n  -webkit-appearance: none;\n  padding: 0;\n  border: none;\n  border-radius: 10px;\n  width: 20px;\n  height: 20px;\n  cursor:pointer;\n  transition: all 0.2s ease-in-out;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 5px 15px 0px!important\n}\n.color-picker::-webkit-color-swatch {\n  border: none;\n  border-radius: 10px;\n  padding: 0;\n}\n.color-picker::-webkit-color-swatch-wrapper {\n  border: none;\n  border-radius: 10px;\n  padding: 0;\n}\n.color-picker:hover {\n  transform: scaleX(1.3) scaleY(1.3);\n  box-shadow: rgba(0, 0, 0, 0.6) 0px 2px 5px 0px!important\n}\n\n.color-picker:focus {\n  transform: scaleX(1.3) scaleY(1.3);\n  box-shadow: rgba(0, 0, 0, 0.6) 0px 2px 5px 0px!important\n}\n\n\n.assignee-box {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.small-dlight-box-shadow{\n  box-shadow: 0 3px 10px 1px rgba(255, 70, 19, 0.5)\n}\n\n\n.noclip {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
